import {useEffect} from 'react'

export const COLOR = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
}
export const COLOR_CODE = {
  _D0D0D0: '#D0D0D0',
  _3387DF: '#3387DF',
  _DFDFDF: '#DFDFDF',
  _333333: '#333333',
  _4E4E4E: '#4E4E4E',
  _FFFFFF: '#FFFFFF',
  _1D1D1D: '#1D1D1D',
  _EFEFEF: '#EFEFEF',
  _616161: '#616161',
  _d20000: '#d20000',
  _66A5E7: '#66A5E7',
}
export const useSetCSSVariables = () => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      Object.entries(COLOR_CODE).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--color${key}`, value)
      })
    }
  }, [])
}
export const TAG_COLOR = {
  BLACK: '#000000',
  CYAN_500: 'Cyan-500',
  CYAN_700: 'Cyan-700',
  GRAY_100: 'Gray-100',
  GRAY_500: 'Gray-500',
  GREEN_150: 'Green-150',
  GREEN_600: 'Green-600',
  ORANGE_150: 'Orange-150',
  ORANGE_400: 'Orange-400',
  RED_150: 'Red-150',
  RED: 'red',
  GREEN: 'green',
  ORANGE: 'orange',
  BLUE: 'blue',
  GRAY: 'gray',
  RED_600: 'Red-600',
  YELLOW_150: 'Yellow-150',
  YELLOW_400: 'Yellow-400',
  AUXILIARY_300: 'Auxiliary-300',
  AUXILIARY_600: 'Auxiliary-600',
}
